export default "__VITE_ASSET__B4o4b1yh__"